// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3dFGY","signatureBlock":"Footer_signatureBlock__1Ee4J","signature":"Footer_signature__3-C2b"};